import { apiService } from './api';
import { DietPriceRow, DietPricesResponse } from '../types/diet';

class DietPriceService {
  async getDietPrices(priceId: string): Promise<DietPricesResponse> {
    return apiService.get<DietPricesResponse>(`/diet-prices?priceId=${encodeURIComponent(priceId)}`);
  }

  async bulkUpsert(priceId: string, rows: Partial<DietPriceRow>[]): Promise<{ success: boolean; message: string; items: DietPriceRow[] }> {
    return apiService.post<{ success: boolean; message: string; items: DietPriceRow[] }>(`/diet-prices/bulk-upsert`, { priceId, rows });
  }

  async delete(id: string): Promise<{ success: boolean; message: string }> {
    return apiService.delete<{ success: boolean; message: string }>(`/diet-prices/${encodeURIComponent(id)}`);
  }

  async export(priceId: string): Promise<Blob> {
    return apiService.get(`/diet-prices/export?priceId=${encodeURIComponent(priceId)}`, { responseType: 'blob' } as any);
  }
}

export const dietPriceService = new DietPriceService();
